import { Actions, ActionTypes } from '../actions/news';
import { NewsItems } from '../models/news';

export interface State {
  posts?: {
    isLoading?: boolean;
    response?: NewsItems;
  };
  _isLoading?: boolean;
}

/* eslint-disable */
function getInitialState(): State {
  return {
    posts: {
      isLoading: true,
      response: {} as NewsItems
    },
    _isLoading: true
  };
}

export const initialState: State = getInitialState();

/* eslint-disable */
export function reducer(state = initialState, action: Actions): State {
  switch (action.type) {
    case ActionTypes.InitNewsItems: {
      return { ...getInitialState(), _isLoading: true, posts: { isLoading: true } };
    }

    case ActionTypes.GetNewsItemsSuccess: {
      return { ...state, posts: { response: action.payload.newsItems, isLoading: false }, _isLoading: false };
    }

    default:
      return state;
  }
}
